import { memo } from 'react';
import { Panel } from 'ht-styleguide';
import cn from 'classnames';
import StarRating from '@components/UI/StarRating';
import { prevented } from 'src/utils/event';
import { ProductCardTypes } from './productCard.types';
import ProductPrice from './ProductPrice';
import ProductImage from './ProductImage';
import ProductCardCta from './ProductCardCta';
import styles from './productCard.module.scss';

const ProductCard = (props: ProductCardTypes) => {
  const { name, classes, ratingAttributes, onClick = () => {}, showCta = false, showHover = false, showOldStyles = false } = props;
  const serviceTitleStyles = cn('h6', {
    [styles.serviceTitle]: showOldStyles,
  });
  const panelStyles = cn(classes, styles.panel, 'marginTop-small1', {
    [styles.hover]: showHover,
  });

  return (
    <Panel className={panelStyles} largeBorderRadius>
      <div onClick={prevented(onClick)} className={styles.cardContainer}>
        <div className={styles.productCard}>
          <ProductImage {...props} />
          <div className={styles.productCardItems}>
            <p className={serviceTitleStyles}>{name}</p>
            <ProductPrice {...props} />
            {ratingAttributes && (
              <StarRating stars={ratingAttributes.rating} count={ratingAttributes.ratingCount} className={styles.rating} size="sm" />
            )}
          </div>
        </div>
        <ProductCardCta showCta={showCta} buttonText="Book Now" linkText="See Details" {...props} />
      </div>
    </Panel>
  );
};

export default memo(ProductCard);

/*
  ProductCard: Component to show info -  name, reviews, price, image/icon.

  Example Usage:

  import ProductCard from '@components/Sku/ProductCards/ProductCard.tsx';

  <ProductCard onClick={func} hasSubscription={bool} shouldShowImage={bool} buttonText={string} linkText={string} />

  Props:
    onClick: Action for button click
    hasSubscription: whether the user has a subscription or not.
    shouldShowImage: whenever the image is needed
*/
